import { createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatcher } from "../../utils/useDispatcher";
import { getLoanTypes, getLoanType, createLoanType, updateLoanType } from "../../services/loanTypeService";

export const doGetLoanTypes = createAsyncThunk(
  "loanType/doGetLoanTypes",
  async (groupId, { rejectWithValue }) => {
    try {
      const data = await getLoanTypes(groupId);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch loan types");
    }
  }
);

export const doGetLoanType = createAsyncThunk(
  "loanType/doGetLoanType",
  async (id, { rejectWithValue }) => {
    try {
      const data = await getLoanType(id);
      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch loan type");
    }
  }
);

export const doCreateLoanType = createAsyncThunk(
  "loanType/doCreateLoanType",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await createLoanType(payload);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message || "Failed to create loan type" }
      );
    }
  }
);

export const doUpdateLoanType = createAsyncThunk(
  "loanType/doUpdateLoanType",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await updateLoanType(payload);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message || "Failed to update loan type" }
      );
    }
  }
);

export const useGetLoanTypes = () => useDispatcher(doGetLoanTypes);
export const useGetLoanType = () => useDispatcher(doGetLoanType);
export const useCreateLoanType = () => useDispatcher(doCreateLoanType);
export const useUpdateLoanType = () => useDispatcher(doUpdateLoanType);
